import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../types/redux';
import { selectFormFields } from '../../selectors';
import { setError, setFormValid } from '../../slices';
import { ECurrentErrorField } from '../../types/formFields';

export const validateNewbuildingFormFields = createAsyncThunk<void, undefined, IThunkApi>(
  'validateNewbuildingFormFields',
  async (_, _thunkApi) => {
    const { dispatch, getState } = _thunkApi;

    const state = getState();
    const { address, area, roomsCount } = selectFormFields(state);

    if (!address) {
      dispatch(
        setError({
          currentErrorField: ECurrentErrorField.address,
          errorText: 'Укажите адрес или название ЖК',
        }),
      );

      dispatch(setFormValid(false));

      return;
    }

    if (!roomsCount) {
      dispatch(
        setError({
          currentErrorField: ECurrentErrorField.roomsCount,
          errorText: 'Укажите кол-во комнат',
        }),
      );

      dispatch(setFormValid(false));

      return;
    }

    if (!area) {
      dispatch(
        setError({
          currentErrorField: ECurrentErrorField.area,
          errorText: 'Укажите площадь',
        }),
      );

      dispatch(setFormValid(false));

      return;
    }

    if (area > 1000) {
      dispatch(
        setError({
          currentErrorField: ECurrentErrorField.area,
          errorText: 'Недопустимое значение',
        }),
      );

      dispatch(setFormValid(false));

      return;
    }

    dispatch(setFormValid(true));

    return;
  },
);
